module.exports = __webpack_public_path__ + "static/media/far2govt.af774ae4.png";